import { cache } from '@lib/graphql/cache'
import { Timestamp } from '@lib/graphql/havelock/__generated__/graphql'
import { GET_USER_ACCOUNT } from '@lib/graphql/havelock/queries/organization'
import { formatDate as fd } from '@mono/packages/utils/date-utils'

export const formatDate = (
  timeStamp: Timestamp | undefined,
  withTime?: boolean
) => {
  const data = cache.readQuery({
    query: GET_USER_ACCOUNT,
  })

  return fd({
    timeStamp,
    withTime,
    dateFormatPreferences: data?.getCurrentUserAccount?.datePreferences,
  })
}
